// @ts-strict-ignore
import { getFormattedDate } from './getFormattedDate'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, OldHeading, Image, OldText } from '@gassan-ui'
import { cn } from '@lib/cn'
import { getUrlSlugInLocale } from '@lib/get-url-slug-in-locale'
import { Item, getKontentImage } from '@lib/kontent'
import { NewsItem } from '@lib/kontent/models/NewsItem'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

export const NewsLink = styled.a`
  display: contents;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      h2,
      h3 {
        text-decoration: underline;
      }

      picture {
        opacity: 0.8;
      }
    }
  }
`

type Props = Item<NewsItem>

const FeaturedItem: FC<Props> = ({ elements }) => {
  const {
    i18n: { language },
  } = useTranslation()
  const {
    featured_desktop_mobile_image,
    featured_tablet_image,
    featured_description,
    featured_title,
  } = elements
  if (
    !featured_desktop_mobile_image.value[0] ||
    !featured_tablet_image.value[0] ||
    !featured_description ||
    !featured_title
  )
    return null
  return (
    <LocalizedLink href={`/${getUrlSlugInLocale('newsPage', language)}/${elements.url_slug.value}`}>
      <NewsLink>
        <Box
          as="a"
          display={{ _: 'block', medium: 'grid' }}
          gridTemplateColumns={{ medium: 'repeat(6, 1fr)' }}
          gridColumnGap={{ _: '1.5rem', large: '2rem' }}
        >
          <Box gridColumn={{ _: '1 / span 3', large: '1 / span 4' }}>
            <Image
              className={cn('aspect-square', 'md:aspect-[10/9]', 'lg:aspect-square')}
              sources={[
                getKontentImage(elements.featured_desktop_mobile_image.value[0].url, {
                  width: 600,
                }),
                getKontentImage(elements.featured_tablet_image.value[0].url, {
                  width: 600,
                }),
                getKontentImage(elements.featured_desktop_mobile_image.value[0].url, {
                  width: 600,
                }),
                getKontentImage(elements.featured_desktop_mobile_image.value[0].url, {
                  width: 1000,
                }),
              ]}
              alt={featured_desktop_mobile_image.value[0].description}
              placeholderSrc={getKontentImage(elements.featured_desktop_mobile_image.value[0].url, {
                width: 50,
              })}
            />
          </Box>
          <Box
            mt={{ _: '1.5rem', medium: '1rem', large: '0.5rem' }}
            gridColumn={{ _: '4 / span 3', large: '5 / span 2' }}
          >
            <OldHeading variant="h3" as="h2" mb={{ _: '1rem', medium: '1.5rem' }}>
              {featured_title.value}
            </OldHeading>
            <OldText style={{ whiteSpace: 'pre-line' }} mb="1.5rem">
              {featured_description.value}
            </OldText>
            <OldText color="shades.500">
              {getFormattedDate(elements.publication_date.value, language)}
            </OldText>
          </Box>
        </Box>
      </NewsLink>
    </LocalizedLink>
  )
}

export default FeaturedItem
